module.exports = __webpack_public_path__ + "img/office-green.082af90e.webp";